/**
 * Hub Editoriale — accordion gallery (ultimi post WP).
 *
 * @package HelloElementorChild
 */

var HIGHLIGHTS_MOBILE_MQ = window.matchMedia('(max-width: 1023px)');

function getHighlightItems(root) {
  var gallery = root.querySelector('[data-camst-highlights-gallery]');

  if (!gallery) {
    return [];
  }

  return Array.prototype.slice.call(gallery.querySelectorAll('[data-camst-highlights-item]'));
}

function setActiveHighlightItem(items, index) {
  items.forEach(function (item, itemIndex) {
    var isActive = itemIndex === index;

    item.classList.toggle('is-active', isActive);
    item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
  });
}

function expandAllHighlightItems(items) {
  items.forEach(function (item) {
    item.classList.add('is-active');
    item.setAttribute('aria-expanded', 'true');
  });
}

function applyHighlightsLayout(root, items) {
  var activeIndex = items.findIndex(function (item) {
    return item.classList.contains('is-active');
  });

  if (activeIndex < 0) {
    activeIndex = 0;
  }

  if (HIGHLIGHTS_MOBILE_MQ.matches) {
    expandAllHighlightItems(items);
    root.classList.add('camst-highlights--stacked');
    return;
  }

  root.classList.remove('camst-highlights--stacked');
  setActiveHighlightItem(items, activeIndex);
}

function isStackedHighlightsRoot(root) {
  return root.classList.contains('camst-highlights--stacked');
}

export function initCamstHighlights(scope) {
  var roots = scope
    ? Array.prototype.slice.call(scope.querySelectorAll('[data-camst-highlights]'))
    : [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-highlights]'));
  } else if (scope.matches && scope.matches('[data-camst-highlights]')) {
    roots = [scope];
  }

  roots.forEach(function (root) {
    var items = getHighlightItems(root);

    if (!items.length) {
      return;
    }

    applyHighlightsLayout(root, items);

    if (root.dataset.camstHighlightsInit === '1') {
      return;
    }

    var gallery = root.querySelector('[data-camst-highlights-gallery]');

    items.forEach(function (item, index) {
      item.addEventListener('mouseenter', function () {
        if (isStackedHighlightsRoot(root)) {
          return;
        }

        setActiveHighlightItem(items, index);
      });

      item.addEventListener('focus', function () {
        if (isStackedHighlightsRoot(root)) {
          return;
        }

        setActiveHighlightItem(items, index);
      });

      item.addEventListener('click', function (event) {
        if (isStackedHighlightsRoot(root)) {
          return;
        }

        if (!item.classList.contains('is-active')) {
          event.preventDefault();
          setActiveHighlightItem(items, index);
        }
      });
    });

    if (gallery) {
      gallery.addEventListener('mouseleave', function () {
        if (isStackedHighlightsRoot(root)) {
          return;
        }

        setActiveHighlightItem(items, 0);
      });
    }

    function onLayoutChange() {
      applyHighlightsLayout(root, items);
    }

    if (typeof HIGHLIGHTS_MOBILE_MQ.addEventListener === 'function') {
      HIGHLIGHTS_MOBILE_MQ.addEventListener('change', onLayoutChange);
    } else if (typeof HIGHLIGHTS_MOBILE_MQ.addListener === 'function') {
      HIGHLIGHTS_MOBILE_MQ.addListener(onLayoutChange);
    }

    root.dataset.camstHighlightsInit = '1';
  });
}

export function teardownCamstHighlights(scope) {
  var roots = scope
    ? Array.prototype.slice.call(scope.querySelectorAll('[data-camst-highlights]'))
    : [];

  if (!scope) {
    return;
  }

  if (scope.matches && scope.matches('[data-camst-highlights]')) {
    roots = [scope];
  }

  roots.forEach(function (root) {
    delete root.dataset.camstHighlightsInit;
    root.classList.remove('camst-highlights--stacked');
  });
}
